"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const persistentDataUpdated = graphql_tag_1.default `
  subscription($environmentId: String!, $key: String!) {
    persistentDataUpdated(environmentId: $environmentId, key: $key) {
      environmentId
      key
      value
      agentId
      type
    }
  }
`;
exports.default = persistentDataUpdated;
//# sourceMappingURL=persistentDataUpdated.js.map